module.exports = __webpack_public_path__ + "1283ae89f071478a84964f8ecb6fb91b.MP3";